/**
 * Helpers purs pour le rappel « Actualise tes matières » (migration 0226).
 *
 * Rien n'est jamais perdu quand un élève change de niveau ou de matières
 * (`attempts`/`student_objectives`/XP référencent l'exercice fait, pas les
 * matières courantes) — ces helpers pilotent juste un bandeau non bloquant
 * qui invite l'élève à revoir ses matières au bon moment : quand son niveau
 * a changé, ou à chaque nouvelle rentrée scolaire (1er septembre).
 */

/** Le 1er septembre le plus récent, en UTC (rentrée scolaire). */
export function mostRecentSchoolYearStart(now: Date): Date {
  const septemberIndex = 8; // 0-indexé
  const year =
    now.getUTCMonth() >= septemberIndex ? now.getUTCFullYear() : now.getUTCFullYear() - 1;
  return new Date(Date.UTC(year, septemberIndex, 1));
}

/**
 * Vrai si l'élève doit revoir ses matières : jamais revues, revues avant son
 * dernier changement de niveau, ou revues avant la dernière rentrée scolaire.
 */
export function needsSubjectsReview(
  subjectsReviewedAt: string | null | undefined,
  levelChangedAt: string | null | undefined,
  now: Date,
): boolean {
  if (!subjectsReviewedAt) return true;
  const reviewed = new Date(subjectsReviewedAt);
  if (levelChangedAt && reviewed.getTime() < new Date(levelChangedAt).getTime()) return true;
  if (reviewed.getTime() < mostRecentSchoolYearStart(now).getTime()) return true;
  return false;
}
